import { createContext, useContext, useMemo } from 'react';
import { useInboxData } from '../hooks/useInboxData';

const InboxContext = createContext(null);

export const useInboxContext = () => {
  const context = useContext(InboxContext);
  if (!context) {
    throw new Error('useInboxContext must be used within InboxProvider');
  }
  return context;
};

export const InboxProvider = ({ children }) => {
  const inboxData = useInboxData();

  const value = useMemo(() => inboxData, [inboxData]);

  return (
    <InboxContext.Provider value={value}>
      {children}
    </InboxContext.Provider>
  );
};
